import { t } from '@lingui/core/macro';
import { ButtonGroup, IconButton } from '@pocketlaw/tetris';
import { Falcon } from '@pocketlaw/tetris/macro';
import { useSearchContext } from 'app/domains/global-search';
import { withFilterErrorBoundary } from '../FilterErrorBoundary';
import { Container, IconContainer, StyledInput } from './styled';
export const QueryFilter = withFilterErrorBoundary((props) => {
    const { placeholder, action } = props;
    const { isSubmitting, setQuery, clearQuery, values } = useSearchContext();
    const { query } = values;
    const defaultPlaceholder = t({ message: 'Search', comment: 'Insights: Query filter placeholder' });
    const handleSetQuery = (event) => {
        setQuery(event.target.value);
    };
    return (<ButtonGroup>
      <Container>
        <IconContainer>
          <Falcon icon="magnifying-glass" $color="text.100"/>
        </IconContainer>
        <StyledInput placeholder={placeholder || defaultPlaceholder} onChange={handleSetQuery} value={query}/>
        <IconButton type="button" size="xs" appearance="ghost" onClick={clearQuery} disabled={!query.length || isSubmitting}>
          <Falcon icon="xmark"/>
        </IconButton>
      </Container>
      {action}
    </ButtonGroup>);
});
